import React from "react";
import HeadImg from "../../../assets/Exactness/Header/Bg.svg";

const Header = () => {
  const handlenav = () => {
    window.location.href = process.env.REACT_APP_BASE_URL;
  };
  return (
    <div className="relative flex h-[60vh] flex-col 2xl:h-[50vh]">
      <img
        src={HeadImg}
        alt="Header Background"
        className="bottom-0 left-0 w-full h-[60vh] object-cover 2xl:h-[50vh]"
      />
      <div className="absolute inset-0 flex flex-col items-center justify-center z-10">
        <div className="text-center max-w-3xl px-8 md:px-10 lg:p-10">
          <p className="text-xl text-[1.7rem] font-medium leading-[1.67] text-gray-700">
            Bulk Email Finder
          </p>
          <h1 className="text-3xl md:text-[42px] font-semibold text-center mt-2 !leading-[1.25]">
            <span className="block text-[#00408C]">Find Lots of Emails</span>
            <span className="block text-black">Fast and Accurate</span>
          </h1>
          <div className="w-full flex justify-center mt-6 mb-3">
            <button
              onClick={handlenav}
              className="text-white bg-background hover:bg-hover font-semibold p-3 rounded-md hover:text-white w-[220px]"
            >
              Get Bulk Emails
            </button>
          </div>
          <p className="text-[13.5px] text-gray-400">
            Find your perfect plan—easy sign-up.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Header;
